<template>
  <div class="collapseNav">
    <ul :id="'level'+collapseMenu[0].id" class="panel-group">
      <li v-for="(oneItem,idx) in collapseMenu" class="panel">
        <a data-toggle="collapse" class="collapsed" :data-parent="'#level'+collapseMenu[0].id" :href="'#menu'+oneItem.itemId[0].id">
          {{oneItem.name}}<span class="collapseArrow"></span>
        </a>
        <div :id="'menu'+oneItem.itemId[0].id" class="panel-collapse collapse">
          <div class="panel-body">
            <ul>
              <li v-for="(item,index) in oneItem.itemId">
                <!--<v-collapseNav v-if="item.itemId==null" :collapseMenu="item"></v-collapseNav>-->
                <a @click="childHelp(oneItem.name,item.name,$event)">{{item.name}}</a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
//  import collapseNav from '@/components/collapseNav'
  export default {
    name: 'collapseNav',
    props: ['collapseMenu'],
    data () {
      return {
      }
    },
    created () {
    },
    mounted () {
      this.queryNum();
    },
    methods: {
      childHelp(className,val,e){
        if(e){
          $(e.target).parent('li').addClass('current')
          $(e.target).parent('li').siblings('li').removeClass('current')
        }
        this.$emit('fatherData',{classA:className,classB:val})
        
        
      },
      queryNum(){
        if(this.$route.query.idNum == 11){
//          $('#menu1').collapse({
//            toggle: true
//          })
          $('#menu1').addClass('in');
          $('#menu1').find('li').eq(0).addClass('current');
          $('#menu1').siblings('a').removeClass('collapsed');
        }else if(this.$route.query.idNum == 12){
          $('#menu1').addClass('in');
          $('#menu1').find('li').eq(1).addClass('current');
          $('#menu1').siblings('a').removeClass('collapsed');
          this.childHelp('新手入门','注册')
        }else if(this.$route.query.idNum == 21){
          $('#menu21').addClass('in');
          $('#menu21').find('li').eq(0).addClass('current');
          $('#menu21').siblings('a').removeClass('collapsed');
          this.childHelp('供应商帮助','征信报告操作指引')
        }else if(this.$route.query.idNum == 22){
          $('#menu21').addClass('in');
          $('#menu21').find('li').eq(1).addClass('current');
          $('#menu21').siblings('a').removeClass('collapsed');
          this.childHelp('供应商帮助','商机查询')
        }else if(this.$route.query.idNum == 31){
          $('#menu31').addClass('in');
          $('#menu31').find('li').eq(0).addClass('current');
          $('#menu31').siblings('a').removeClass('collapsed');
          this.childHelp('采购商帮助','采购方用户操作概览')
        }else if(this.$route.query.idNum == 32){
          $('#menu31').addClass('in');
          $('#menu31').find('li').eq(1).addClass('current');
          $('#menu31').siblings('a').removeClass('collapsed');
          this.childHelp('采购商帮助','用户共享资源查询')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/collapseNav/index.vue